import { render, staticRenderFns } from "./effects.vue?vue&type=template&id=21e92fd6&scoped=true&"
import script from "./effects.vue?vue&type=script&lang=js&"
export * from "./effects.vue?vue&type=script&lang=js&"
import style0 from "./effects.vue?vue&type=style&index=0&id=21e92fd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e92fd6",
  null
  
)

export default component.exports